// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Afghanistan */
const AF = /^(?:7\d{8})$/;

export default AF;
